import { pickBy } from '@/utils'
import CtaItem from './ctaItem.vue'
import TitleItem from './titleItem.vue'
export const proportions = [
  {
    label: 0,
    name: '16:9'
  },
  {
    label: 1,
    name: '9:16'
  },
  {
    label: 2,
    name: '4:3'
  },
  {
    label: 3,
    name: '3:4'
  },
  {
    label: 4,
    name: '1:1'
  }
]
export const typeRadioData = [
    {
        label: 0,
        name: '图片'
    },
    {
        label: 1,
        name: '视频'
    },
]

export default {
    name: 'HmStage',
    setting:[
        {
            key:'radio',
            label: '类型',
            component: 'radio',
            options: typeRadioData,
            value: 0
        },
        {
          key:'titleData',
          label: '标题',
          component: function (h, {key}){
            return <TitleItem v-model={this.value[key]}></TitleItem>
          },
          value: {
            title: '标题',
            color: '#FFF'
          }
        },
        {
          label: '视频比例',
          key: 'proportion',
          component: 'radio',
          options: proportions,
          value: 1,
          isShow: function () {
            return false
          },
        },
        {
            label: '选择视频',
            key: 'video',
            component: function (h, { key }) {
                return <SpVideoPicker v-model={this.value[key]} size='small' />
            },
            isShow: function () {
                return this.value.radio == '1'
            },
            value: ''
        },
        {
            label: '选择图片',
            key: 'img',
            component: function (h, { key }) {
              return <SpImagePicker v-model={this.value[key]} size='small' />
            },
            value: '',
            isShow: function () {
                return this.value.radio == '0'
            },
        },
        {
          label: '按钮',
          key: 'cta',
          component: function (h, { key }){
            return <CtaItem  v-model={this.value[key]}></CtaItem>
          },
          value: {
            desc: '立即选购',
            urlData: {}
          }
        }
    ],
    transformIn: (v) => {
        const {
            name,
            base,
            config
        } = v
        return {
            name,
            ...base,
            ...config
        }
    },
    transformOut:(v) => {
        return pickBy(v, {
            name: 'name',
            base: (v) => {
              return pickBy(v, {
              })
            },
            config: (v) => {
              return pickBy(v, {
                video: 'video',
                img: 'img',
                cta: 'cta',
                titleData: 'titleData',
                radio: 'radio',
                proportion: 'proportion',
              })
            }
          })
    }
}
